<template>
  <div class="board-number container">
    <div class="board-number-one" @click="handleShowBio(0)">
      <div class="sack-img-bio">
        <img class="image-banner" src="../assets/images/Tuan Hua.png" alt="" />
        <div class="bio">
          "18+ years in tech startups in C-suite leadership positions. Built Vietnam’s first cloud-based POS platform (maybanhang.net, serving 15K+ merchants), Vietnam’s first
          stock exchange platform (Kim Long Securities), and the world’s first blockchain loyalty app (EZToken Rewards)."
        </div>
      </div>
      <div class="teammate-name">Tuan Hua</div>
      <div class="teammate-des">Chief Executive Officer</div>
    </div>
    <div class="board-number-one" @click="handleShowBio(1)">
      <div class="sack-img-bio">
        <img class="image-banner" src="../assets/images/peter-thai.png" alt="" />
        <div class="bio">
          "Ph.D. in Engineering from National University of Singapore. 6+ years experience in academic research. 5+ years in blockchain-related startup beyond scientific pursuits.
          An entrepreneur, angel investor and marketing advisor in the blockchain business."
        </div>
      </div>
      <div class="teammate-name">Dr. Peter Thai</div>
      <div class="teammate-des">Chief Operation Officer</div>
    </div>
    <div class="board-number-one" @click="handleShowBio(2)">
      <div class="sack-img-bio">
        <img class="image-banner" src="../assets/images/laurent.png" alt="" />
        <div class="bio">
          "Ph. D. in Applied Mathematics from Ecole Polytechnique (#1 in France). 10 years working for EY France (Big 4 in the world), 5+ years for tech startups in Vietnam,
          Australia and Malaysia, and 3 years of R&D in France."
        </div>
      </div>
      <div class="teammate-name">Dr. Laurent Nguyen</div>
      <div class="teammate-des">Chief Financial Officer</div>
    </div>
    <div class="board-number-one" @click="handleShowBio(3)">
      <div class="sack-img-bio">
        <img class="image-banner" src="../assets/images/David Tran.png" alt="" />
        <div class="bio">
          "Blockchain Professor, Univ of Massachusetts, USA. General Partner of IDG Capital Vietnam Blockchain. 15+ years in blockchain-related research and development. An
          entrepreneur, investor, advisor, and speaker in the blockchain business."
        </div>
      </div>
      <div class="teammate-name">Dr. David Tran</div>
      <div class="teammate-des">Blockchain Professor</div>
    </div>

    <!-- <div class="board-number-one">
      <div class="sack-img-bio">
        <img
          class="image-banner"
          src="../assets/images/thanhnguyen.png"
          alt=""
        />
        <div class="bio">
          "Deputy General Director of LPBank. 16+ years of leadership in
          Business Development and Technology. Currently, Deputy General
          Director & IT Chief of Lien Viet Post Bank. Previously, Head of
          Marketing Research & Mobile Service at Viettel Group and Product
          Director at Huawei Vietnam. "
        </div>
      </div>
      <div class="teammate-name">Thanh Nguyen</div>
      <div class="teammate-des">Chief Business Officer</div>
    </div> -->
    <!-- <div class="board-number-one">
      <div class="sack-img-bio">
        <img class="image-banner" src="../assets/images/truongnguyen.png" alt="" />
        <div class="bio">
          "Founder/CEO of Van Dough, a fast growing bakery chain in Brisbane, Australia with $20m yearly revenue. An early enthusiast, entrepreneur, and investor in blockchain
          business, having led as CEO of EZToken Rewards, the world's first crypto loyalty app."
        </div>
      </div>
      <div class="teammate-name">Van Nguyen</div>
      <div class="teammate-des">Chief Global Officer</div>
    </div> -->

    <!-- Dialog -->
    <el-dialog :visible.sync="dialogVisible" class="dialog-bio">
      <p class="dialog-title">{{ list[index].title }}</p>
      <p class="dialog-position">{{ list[index].position }}</p>
      <p class="dialog-bio">{{ list[index].bio }}</p>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        index: 0,
        dialogVisible: false,
        list: [
          {
            title: 'Tuan Hua',
            position: 'Chief Executive Officer',
            bio: '18+ years in tech startups in C-suite leadership positions. Built Vietnam’s first cloud-based POS platform (maybanhang.net, serving 15K+ merchants), Vietnam’s first stock exchange platform (Kim Long Securities), and the world’s first blockchain loyalty app (EZToken Rewards).'
          },
          {
            title: 'Dr. Peter Thai',
            position: 'Chief Operation Officer',
            bio: `Ph.D. in Engineering from National University of Singapore. 6+ years experience in academic research. 5+ years in blockchain-related startup beyond scientific pursuits.
          An entrepreneur, angel investor and marketing advisor in the blockchain business.`
          },
          {
            title: 'Dr. Laurent Nguyen',
            position: 'Chief Financial Officer',
            bio: `Ph. D. in Applied Mathematics from Ecole Polytechnique (#1 in France). 10 years working for EY France (Big 4 in the world), 5+ years for tech startups in Vietnam,
          Australia and Malaysia, and 3 years of R&D in France.`
          },
          {
            title: 'Dr. David Tran',
            position: 'Blockchain Professor',
            bio: `Blockchain Professor, Univ of Massachusetts, USA. General Partner of IDG Capital Vietnam Blockchain. 15+ years in blockchain-related research and development. An
          entrepreneur, investor, advisor, and speaker in the blockchain business.`
          }
        ]
      }
    },
    methods: {
      handleShowBio(index) {
        if (window.innerWidth < 768) {
          this.index = index
          this.dialogVisible = true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep.dialog-bio {
    .el-dialog {
      background: #21242a;
      width: calc(100vw - 30px);
      * {
        color: #fff;
      }

      &__header {
        .el-icon-close {
          font-size: 24px;
        }
      }
      &__body {
        padding: 10px 20px 30px;
        text-align: left;
        .dialog-title {
          font-size: 34px;
          line-height: 58px;

          @media screen and (max-width: 390px) {
            font-size: 30px;
          }
        }
        .dialog-position {
          margin-bottom: 25px;
          font-size: 20px;
          line-height: 36px;
        }
        .dialog-bio {
          margin-bottom: 15px;
          font-size: 16px;
          line-height: 27px;
          font-weight: 400;
          word-break: break-word;
        }
      }
    }
  }

  @keyframes chageHover {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .sack-img-bio:hover .bio {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    overflow: hidden;
  }
  .bio {
    background: url(../assets/images/hover.png);
    position: absolute;
    left: 50%;
    top: 0px;
    transform: translateX(-50%);
    width: 250px;
    height: 100%;
    background-repeat: no-repeat;
    display: none;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    transition: 1s ease;
    opacity: 0;
    color: #fafafa;
    text-align: center;
    cursor: pointer;
    padding-top: 9%;
    padding-left: 17px;
    padding-right: 16px;
    animation: chageHover linear 0.5s;
  }

  .board-number {
    // max-width: 1400px;
    // margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    text-align: center;
    gap: 30px;
    // @media (max-width: 1440px) {
    //   max-width: 1360px;
    // }

    @media (max-width: 1028px) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 30px;
    }
    @media (max-width: 739px) {
      grid-template-columns: 1fr;
      grid-gap: 30px;
    }
    .teammate-name {
      font-size: 2.4rem;
      line-height: 3.6rem;
      font-weight: 400;
      color: #414c63;
      margin-top: 2.9rem;
      @media (max-width: 739px) {
        font-size: 1.8rem;
        margin-top: 1.6rem;
      }
    }
    .teammate-des {
      font-size: 1.6rem;
      line-height: 1.9rem;
      font-weight: 400;
      color: #c4c4c4;

      @media (max-width: 739px) {
        font-size: 1.4rem;
      }
    }
  }
  @media (max-width: 1300px) {
    .bio {
      display: none !important;
    }
  }
  .sack-img-bio {
    position: relative;
    @media (max-width: 739px) {
      .image-banner {
        height: 224px;
      }
    }
  }
</style>
